import { Breadcrumbs as MuiBreadcrumbs, Typography, Link as MuiLink } from "@mui/material"
import { Link } from "react-router-dom"

const Breadcrumb = ({ items }) => {
  return (
    <MuiBreadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return isLast ? (
          <Typography key={index} color="text.primary">
            {item.label}
          </Typography>
        ) : (
          <MuiLink key={index} component={Link} to={item.href} color="inherit" underline="hover">
            {item.label}
          </MuiLink>
        )
      })}
    </MuiBreadcrumbs>
  )
}

export default Breadcrumb

